'use client';

import React from 'react';

interface RoleSelectorProps {
  selectedRole: string;
  onRoleSelect: (role: string) => void;
}

const RoleSelector = ({ selectedRole, onRoleSelect }: RoleSelectorProps) => {
  const roles = [
    { id: 'master-control', label: 'Master Control', color: 'bg-blue-100 text-blue-800 border-blue-200' },
    { id: 'company-admin', label: 'Company Admin', color: 'bg-amber-100 text-amber-800 border-amber-200' },
    { id: 'interior-designer', label: 'Interior Designer', color: 'bg-gray-100 text-gray-800 border-gray-200' },
    { id: 'client', label: 'Client', color: 'bg-primary/10 text-primary border-primary/20' }
  ];

  return (
    <div data-component-id="src/app/authentication-login/components/RoleSelector.tsx:19:4" data-component-path="src/app/authentication-login/components/RoleSelector.tsx" data-component-line="19" data-component-file="RoleSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-3%22%7D" className="space-y-3">
      <label data-component-id="src/app/authentication-login/components/RoleSelector.tsx:20:6" data-component-path="src/app/authentication-login/components/RoleSelector.tsx" data-component-line="20" data-component-file="RoleSelector.tsx" data-component-name="label" data-component-content="%7B%22elementName%22%3A%22label%22%2C%22className%22%3A%22block%20text-sm%20font-medium%20text-foreground%22%2C%22textContent%22%3A%22Select%20Your%20Role%22%7D" className="block text-sm font-medium text-foreground">
        Select Your Role
      </label>
      <div data-component-id="src/app/authentication-login/components/RoleSelector.tsx:23:6" data-component-path="src/app/authentication-login/components/RoleSelector.tsx" data-component-line="23" data-component-file="RoleSelector.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20gap-2%22%7D" className="grid grid-cols-2 gap-2">
        {roles.map((role) => (
          <button data-component-id="src/app/authentication-login/components/RoleSelector.tsx:25:10" data-component-path="src/app/authentication-login/components/RoleSelector.tsx" data-component-line="25" data-component-file="RoleSelector.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%7D"
            key={role.id}
            type="button"
            onClick={() => onRoleSelect(role.id)}
            className={`px-3 py-2 text-xs font-medium rounded-lg border transition-all duration-300 ease-spring ${
              selectedRole === role.id
                ? role.color + ' shadow-warm-sm'
                : 'bg-muted text-muted-foreground border-border hover:bg-muted/80'
            }`}
          >
            {role.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RoleSelector;